import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import Icon from '@mui/material/Icon';

const feedbackFormUrl = process.env.REACT_APP_FEEDBACK_LINK || 'https://docs.google.com/forms/d/e/YOUR-FORM-ID/viewform'; // Fallback URL

const FeedbackButton: React.FC = () => {
  const openFeedbackPage = () => window.open(feedbackFormUrl, '_blank', 'noopener,noreferrer');

  return (
    <Tooltip title='Add Feedback' placement='right'>
      <IconButton onClick={openFeedbackPage} sx={styles.button}>
        <Icon sx={styles.icon}>feedback</Icon>
      </IconButton>
    </Tooltip>
  );
};

const styles = {
  button: {
    //styling for global button commented for now
    // position: 'fixed',
    // bottom: 35,
    // left: 30,
    // width: 48,
    // height: 48,
    backgroundColor: '#0283a0c4',
    borderRadius: '50%',
    boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
    color: 'white !important',
    textDecoration: 'none',
    cursor: 'pointer',
    zIndex: 1300,
    '&:hover': { backgroundColor: 'primary.main' },
  },
  icon: { fontSize: 28, color: 'white' },
};

export default FeedbackButton;
